'use client';

import { useReferralsInfinite, useReferralStats } from '../../queries/useReferralQueries';
import { useProfile } from '../../queries/useProfileQueries';

export const useReferralsData = () => {
  const {
    data: referralsData,
    isLoading: isLoadingReferrals,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    error: referralsError,
    refetch,
  } = useReferralsInfinite();

  const { data: profile, isLoading: isLoadingProfile } = useProfile();
  const { data: stats, isLoading: isLoadingStats } = useReferralStats();

  const referrals = referralsData?.pages.flatMap((page) => page.referrals) ?? [];
  const totalCount = referralsData?.pages[0]?.meta.totalItems ?? 0;

  const loading = isLoadingReferrals || isLoadingProfile || isLoadingStats;
  const error = !!referralsError;

  const loadMore = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const loadReferrals = () => {
    refetch();
  };

  return {
    referrals,
    totalCount,
    profile: profile ? {
      fullName: profile.fullName,
    } : null,
    stats: stats ? {
      totalReferrals: stats.totalReferrals,
      totalEarned: stats.totalEarned,
      progressToBonus: stats.progressToBonus,
      rewardCredits: stats.rewardCredits,
    } : null,
    loading,
    loadingMore: isFetchingNextPage,
    error,
    loadReferrals,
    loadMore,
  };
};
